export const pngDataForCanvas = async (canvas: OffscreenCanvas) => {
  if (!canvas) return

  const blob = await canvas.convertToBlob({ type: 'image/png' })

  const reader = new FileReader()

  return new Promise((resolve, reject) => {
    reader.onload = () => {
      const dataURL = reader.result

      resolve(dataURL)
    }
    reader.readAsDataURL(blob)
  })
}
